import { useState } from 'react'

import { EmailCreationForm, EmailCreationPopUp } from '../../../Email'
import { Container } from '../../Container'

function EmailsCreationForm() {
  const [modal, setModal] = useState(null)

  function handleOpenModal() {
    setModal(<EmailCreationPopUp onClose={() => setModal(null)} />)
  }

  return (
    <>
      <Container label='new email form' style={{ background: 'white' }}>
        <EmailCreationForm setModal={setModal} />
      </Container>
      <Container label='new email form modal' style={{ background: 'white' }}>
        <div onClick={handleOpenModal}>onClick here</div>
      </Container>
      {modal}
    </>
  )
}

export default EmailsCreationForm
